import * as d3 from 'd3'

export default {

  methods: {

    call_List(selection, idx) {
      selection
      .on('mouseover', () => {
        d3.select(`#ROW_${idx}_${this.localId}`).transition().duration(100)
        .attr('opacity', .3)
      })
      .on('mouseout', () => {
        d3.select(`#ROW_${idx}_${this.localId}`).transition().duration(300)
        .attr('opacity', 0)
      })
    },



    event_Link(selection, data_, col, color_) {

      if (!col.filter || data_[col.code] == 0) return

      selection
      .attr('cursor', 'pointer')
      .on('mouseover', function() {
        d3.select(this).transition().duration(100).attr('fill', '#EC407A')
      })
      .on('mouseout', function() {
        d3.select(this).transition().duration(300).attr('fill', color_)
      })
      .on('click', () => {
        this.link_Action(data_, this.filters[col.filter], col) 
      })
    },

    link_Action(data_, filter_, col) {

      let dataSource = {}

      Object.keys(this.keys).forEach(d=>{
        dataSource = {...dataSource, [d]: data_[this.keys[d]]}
      })
      let filterString_ = filter_ || ''

      let reqText = col.json || 'request'

      // seting request_ from A/G jsonProps
      let request_ = this.getRequestColumnProps(reqText, dataSource, this.ColumnProps)
      if(!request_) return

      if(request_.iFilters.filterString) {
        request_.iFilters.filterString += filterString_ ? ` AND ${filterString_} ` : ''
      } else {
        request_.iFilters.filterString = filterString_||''
      }

      // Combine filterStrings
      request_ = {...request_,
        filters : {
          ...this.FilterValues,
          ...request_.filters,
        },
        iFilters: { 
          filterString : request_.iFilters.filterString||'',
          inputFilter : request_.iFilters.inputFilter,},
      }
      this.$emit('request-action', request_)
    },

  } 
}